import requestDefault from '@/shared/utils/request';
import {
  CouponPo, CouponRolePo, CouponRoleVo, CouponStateTypeEnum, CouponVo,
} from './types';

// 获取‘我的优惠券’列表（区分逾期和非逾期）
export const getMyCouponList = (
  formData: CouponVo,
  couponStateType: CouponStateTypeEnum,
): Promise<CouponPo[]> => requestDefault.postGate<CouponPo[]>('f.activity.couponList',
  { ...formData, couponStateType });

// 获取用户规则优惠券列表
export const getRuleSetCouponList = (
  formData: CouponRoleVo,
): Promise<CouponRolePo[]> => requestDefault.postGate<CouponRolePo[]>('f.activity.ruleSetCouponList',
  { ...formData });
